import React from 'react';
import { Box, SimpleGrid, Text } from '@chakra-ui/react';

import { SummaryRow } from '../../../../services/feedAnalysisService';
import { formatPercent, STATUS_STYLE } from '../format';

interface KpiCardsProps {
  summary: SummaryRow;
}

// contagem de nutrientes por status e % ideal, como o topo da aba do mês
export const KpiCards: React.FC<KpiCardsProps> = ({ summary }) => {
  const cards = [
    {
      label: '% Ideal',
      value: formatPercent(summary.ideal_rate),
      hint: `${summary.samples} amostra(s)`,
      accent: 'blue.300',
    },
    {
      label: STATUS_STYLE.ideal.label,
      value: summary.ideal,
      hint: 'dentro da faixa',
      accent: STATUS_STYLE.ideal.bg,
    },
    {
      label: STATUS_STYLE.below.label,
      value: summary.below,
      hint: 'abaixo da faixa',
      accent: STATUS_STYLE.below.bg,
    },
    {
      label: STATUS_STYLE.above.label,
      value: summary.above,
      hint: 'acima da faixa',
      accent: STATUS_STYLE.above.bg,
    },
    {
      label: 'Sem referência',
      value: summary.no_reference,
      hint: 'sem valor do nutricionista',
      accent: 'gray.500',
    },
  ];

  return (
    <SimpleGrid columns={{ base: 2, md: 5 }} spacing="3" mb="6">
      {cards.map(card => (
        <Box
          key={card.label}
          bg="gray.800"
          borderWidth="1px"
          borderColor="gray.700"
          borderTopWidth="3px"
          borderTopColor={card.accent}
          borderRadius="lg"
          p="4"
        >
          <Text fontSize="sm" color="gray.400" fontWeight="500">
            {card.label}
          </Text>
          <Text fontSize="2xl" fontWeight="700" color="gray.50">
            {card.value}
          </Text>
          <Text fontSize="xs" color="gray.500">
            {card.hint}
          </Text>
        </Box>
      ))}
    </SimpleGrid>
  );
};
